<template>
  <nav
    class="navbar navbar-expand-lg navbar-absolute"
    :class="{'bg-white': showMenu, 'navbar-transparent': !showMenu}"
  >
    <div class="container-fluid">
      <div class="navbar-wrapper">
        <router-link  to="/" class="navbar-brand">Terra Aqua Kontrolni Panel</router-link>
      </div>
      <button
        class="navbar-toggler"
        type="button"
        @click="toggleMenu"
        data-toggle="collapse"
        data-target="#navigation"
        aria-controls="navigation-index"
        aria-label="Toggle navigation"
      >
        <span class="navbar-toggler-bar navbar-kebab"></span>
        <span class="navbar-toggler-bar navbar-kebab"></span>
        <span class="navbar-toggler-bar navbar-kebab"></span>
      </button>

      <collapse-transition>
        <div class="collapse navbar-collapse show" v-show="showMenu">
          <ul class="navbar-nav" :class="'ml-auto'">
            <li class="nav-item">
              <router-link class="nav-link" to="/">
                <i class="tim-icons icon-components"></i>
                <p class="d-lg-none">PANEL</p>
              </router-link>
            </li>
            <li class="nav-item">
              <router-link class="nav-link" to="/stats">
                <i class="tim-icons icon-chart-bar-32"></i>
                <p class="d-lg-none">STATISTIKA</p>
              </router-link>
            </li>
            <!--
            <li class="nav-item">
              <router-link class="nav-link" to="/alarms">
                <i class="tim-icons icon-bell-55"></i>
                <p class="d-lg-none">ALARMI</p>
              </router-link>
            </li>
            <li class="nav-item">
              <router-link class="nav-link" to="/">
                <i class="tim-icons icon-tv-2"></i>
                <p class="d-lg-none">PROMENI PUMPU</p>
              </router-link>
            </li>
            -->
            <base-dropdown
              tag="li"
              :menu-on-right="!$rtl.isRTL"
              title-tag="a"
              class="nav-item"
              menu-classes="dropdown-navbar"
            >
              <a
                slot="title"
                href="#"
                class="dropdown-toggle nav-link"
                data-toggle="dropdown"
                aria-expanded="true"
              >
                <div class="photo">
                  <img src="img/anime3.png" />
                </div>
                <b class="caret d-none d-lg-block d-xl-block"></b>
                <p class="d-lg-none">Profil</p>
              </a>
              <li class="nav-link">
                <router-link  to="/settings" class="nav-item dropdown-item">Podešavanja</router-link>
              </li>
              <div class="dropdown-divider"></div>
              <li class="nav-link">
                <a href="#" class="nav-item dropdown-item" @click="sendLogout">Odjava</a>
              </li>
            </base-dropdown>
          </ul>
        </div>
      </collapse-transition>
    </div>
  </nav>
</template>
<script>
import { CollapseTransition } from "vue2-transitions";
import Modal from "@/components/Modal";

export default {
  components: {
    CollapseTransition,
    Modal
  },
  computed: {
    isRTL() {
      return this.$rtl.isRTL;
    }
  },
  data() {
    return {
      activeNotifications: false,
      showMenu: false,
      searchModalVisible: false,
      searchQuery: ""
    };
  },
  methods: {
    toggleNotificationDropDown() {
      this.activeNotifications = !this.activeNotifications;
    },
    closeDropDown() {
      this.activeNotifications = false;
    },
    toggleMenu() {
      this.showMenu = !this.showMenu;
    },
    sendLogout(){
      localStorage.removeItem("user_jwt");
      this.$router.push("/login")
    }
  }
};
</script>
<style scoped>
.navbar-brand{
  font-weight: bold;
  letter-spacing: 1px;
  font-size: calc(0.6em + 0.4vw) !important;
}
.navbar {
  box-shadow: 0px 2px 4px -1px rgba(0, 0, 0, 0.2), 0px 4px 5px 0px rgba(0, 0, 0, 0.14), 0px 1px 10px 0px rgba(0, 0, 0, 0.12);
}

</style>
